
export default {
    name: 'SvgChevronRight',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
        opacity: {
            type: [String, Number],
            default: 0.4,
        },
    },
};
